import upsellAdditions from "./upsellAdditions";
import manualOrderProduct from "./manualOrderProduct";

export default {
  template: '#launch_campaign_tab',
  components: {
    upsellAdditions,
    manualOrderProduct,
  },
  watch: {
    campaign_name: function(val, oldVal) {
      if (val != '' && val.length < 4) {
        this.name_error = true;
        this.name_error_message = 'Campaign Name cannot be less than 4 characters';
      } else {
        this.name_error = false;
        this.name_error_message = '';
      }
      this.$root.$set('campaignData.campaign_name', val);

      if (this.isAPIOrder()) {
        this.campaign_description = this.campaign_name;
      }
    },
    campaign_description: function(val, oldVal) {
      this.$root.$set('campaignData.campaign_description', val);
    },
    campaign_url: function(val, oldVal) {
      this.validateURL(val);
    },
    campaign_tags: function(val, oldVal) {
      this.$root.$set('campaignData.campaign_tags', val);
    },
    accept_terms: function(val) {
      this.$root.$set('campaignData.accept_terms', val);
    },
    'purchases.buyer.country': function(val) {
      this.manageStateField(val);
    },
    selectedEmailList: function(val) {
      this.$root.$set('campaignData.email_list', val);
    },
    selectedDomainId: function(val) {
      this.$root.$set('campaignData.domain_id', val)
    }
  },
  events: {
    'draft-loaded': function() {
      var draftInfo = this.$root.campaignData;
      var that = this;

      this.$set('campaign_name', draftInfo.campaign_name);
      this.$set('campaign_url', draftInfo.campaign_url + _.uniqueId('-'));
      this.$set('category', draftInfo.category);
      this.$set('source_id', draftInfo.source_id);

      if(this.categoriesDropdownObject !== null) {
        this.categoriesDropdownObject[0].selectize.setValue(parseInt(draftInfo.category));
      }

      this.$set('accept_terms', false);

      $('#campaign_description').html(draftInfo.campaign_description);

      $('#campaign_tags').importTags(draftInfo.campaign_tags.join(','));

      if (draftInfo.campaign_length) {
        var end_date = new Date();

        end_date.setDate(end_date.getDate() + parseInt(draftInfo.campaign_length));
        end_date.setMinutes(0);

        var format = $.fn.datetimepicker.DPGlobal.parseFormat('DD, M. dd yyyy - HH P', 'standard');
        var formatted = $.fn.datetimepicker.DPGlobal.formatDate(end_date, format, 'en', 'standard');

        this.$set('campaign_end_date', formatted);
        this.$set('totalLength', draftInfo.campaign_length + ' Days');

        this.$root.$set('campaignData.campaign_end_date', formatted);
        this.$root.$set('campaignData.campaign_end_date_obj', end_date);

        this.setUTCTime(formatted);
        this.$broadcast('campaign-end-date-changed', end_date);
      }

      $('[name="AUTO-RELAUNCH"]').bootstrapSwitch('state', draftInfo.campaign_auto_relaunch);
      $('[name="PAGE-TIMER"]').bootstrapSwitch('state', draftInfo.campaign_page_timer);
      $('[name="SHOW-GOAL"]').bootstrapSwitch('state', draftInfo.campaign_show_goal);
      $('[name="AUTO-EXTEND"]').bootstrapSwitch('state', draftInfo.campaign_auto_extend);
      $('[name="DTG-AUTO-GOAL-DROP"]').bootstrapSwitch('state', draftInfo.campaign_dtg_auto_goal_drop);
      $('[name="SHOW-BACK-DEFAULT"]').bootstrapSwitch('state', draftInfo.campaign_show_back_default);
      $('[name="discoverable_on_marketplace"]').bootstrapSwitch('state', !draftInfo.hide_marketplace);


      this.selectedEmailList = draftInfo.email_list;

      this.$root.$set('campaignData.domain_id', draftInfo.domain_id != "" ? draftInfo.domain_id : null);
      this.$set('selectedDomainId', draftInfo.domain_id != "" ? draftInfo.domain_id : null);

      this.$set('import_back_images', draftInfo.import_back_images);

      $('[name="import_back_images"]').bootstrapSwitch('state', this.import_back_images);

    },
    'user-logged-in': function() {
      this.fetchEmailList();
      this.getWhitelabelAccountDetails();
    }
  },
  ready: function() {

    this.setupUIEvents();
    this.getCategories();

    //Setting this to false onReady because the checkbox toggles needs to be
    //initialized before they are hidden. The hidden checkboxes don't get initialized.
    this.showAdvanced = false;


  },
  data: function() {
    return {
      campaign_name: '',
      campaign_description: '',
      campaign_url: '',
      url_exists: false,
      url_error_message: '',
      name_error: false,
      name_error_message: '',
      description_error: false,
      description_error_message: '',
      tags_error: false,
      tags_error_message: '',
      campaign_tags: [],
      campaign_end_date: '',
      campaign_upsells: [],
      accept_terms: false,
      totalLength: '-',
      validationFields: '',
      showAdvanced: true,
      category: null,
      productsOrders: [],
      countries: [],
      states: [],
      showStateDropdown: true,
      stateText: '',
      stateDropdown: '',
      stateLabel: 'State',
      zipLabel: 'ZIP Code',
      months: [],
      years: [],
      purchases: {
        buyer: {
          email: '',
          name: '',
          address: '',
          apt: '',
          city: '',
          state: '',
          zip: '',
          country: 'US'
        },
        payment: {
          cc: {
            card_num: '',
            card_month: '',
            card_year: '',
            card_cvv: ''
          }
        }
      },
      rates: {
        subTotal: 0.00,
        shipping: 0.00
      },
      buttonClick: false,
      selectedEmailList: '',
      selectedDomainId: null,
      domainList: [],
      isWhiteLabel: false,
      emailList: [],
      campaignCategories: [],
      selectedCampaignCategory: '',
      whiteLabelURL: '',
      auto_import_to_shopify: false,
      auto_visible_product_shopify: false,
      import_back_images: true,
      shopify_collections: [],
      selectedCollection: '',
      collectionDropdown: null,
      shopifyVariantsEnabled: false,
      categoriesDropdownObject: null,
      source_id: null,
      clone_upsells: false,
      clone_pixels: false
    };
  },
  methods: {
    setupUIEvents() {
      var that = this;

      $(document).on('click', '#resend-validation', function() {
        var requestService = that.$root.service.request.object;
        alertify.alert().close();
        helpers.showProcessing();
        requestService.oAuthPost(`${requestService.apiBase}/resend-validation`, {}, (response) => {
          var res = response.data;
          if (res.status === "SUCCESS") {
            helpers.alert(res.message || 'Welcome email resent.');
            helpers.hideProcessing();
          } else {
            helpers.alert(res.message || 'Unasble to send validation email. Please contact customer support for assistance.');
            helpers.hideProcessing();
          }
        });
      });

      $('#campaign_tags').tagsInput({
        'width': '100%',
        'height': '45px',
        'interactive': true,
        'defaultText': 'add a tag',
        'minChars': 5,
        'maxChars': 30,
        'autocomplete_url': this.$root.getRequestService().ajaxBase + 'tags-suggest',
        onAddTag: function(elem) {
          var tags = $('#campaign_tags').val().split(',');
          if (tags.length > 3) {
            that.tags_error_message = 'No more than 3 tags are allowed';
            that.tags_error = true;
            tags = $('#campaign_tags').val().split(',');
          } else {
            that.tags_error_message = '';
            that.tags_error = false;
          }
          that.$root.$set('campaignData.campaign_tags', tags);
        },
        onChange: function() {
          var tags = $('#campaign_tags').val().split(',');
          that.$root.$set('campaignData.campaign_tags', tags);
        },
        onRemoveTag: function(elem) {
          var tags = $('#campaign_tags').val().split(',');
          if (tags.length <= 10) {
            that.tags_error_message = '';
            that.tags_error = false;
          }
        }
      });


      var triggerEnterForTags = function(elem) {
        var e = jQuery.Event("keypress");
        e.which = 13; //choose the one you want
        e.keyCode = 13;
        elem.trigger(e);
      };

      $('#campaign_tags_tag').on('keydown', function(e) {
        if (e.which === 9) {
          triggerEnterForTags($(e.target));
          $(this).focus();
          e.preventDefault();
        }
      });

      $('#campaign_end_date').datetimepicker({
        startDate: '+4d',
        endDate: '+14d',
        format: 'DD, M. dd yyyy - HH P',
        showMeridian: true,
        autoclose: true,
        todayBtn: true,
        minView: 1,
        maxView: 3
      }).on('changeDate', function(e) {
        var interval = Math.ceil((e.date - new Date()) / 1000 / 60 / 60 / 24);
        that.totalLength = interval + ' Days';
        that.$root.$set('campaignData.campaign_length', interval);
        that.$root.$set('campaignData.campaign_end_date', $('#campaign_end_date').val());
        that.$root.$set('campaignData.campaign_end_date_obj', e.date);
        that.setUTCTime($('#campaign_end_date').val());
        that.$broadcast('campaign-end-date-changed', e.date);
      }).on('change', function() {
        var val = $(this).val();
        if (val == '') {
          that.setDefaultDate();
        }
      }).on('focus', function() {
        $(this).blur();
      });

      this.setDefaultDate();
      this.manageStateField('US');

      $('#campaign_description').wysihtml5({
        toolbar: {
          "fa": true,
          "font-styles": false, //Font styling, e.g. h1, h2, etc. Default true
          "emphasis": true, //Italics, bold, etc. Default true
          "lists": false, //(Un)ordered lists, e.g. Bullets, Numbers. Default true
          "html": false, //Button which allows you to edit the generated HTML. Default false
          "link": true, //Button to insert a link. Default true
          "image": true, //Button to insert an image. Default true,
          "color": false, //Button to change color of font
          "blockquote": false //Blockquote
        },
        events: {
          load: function() {
            $('[data-wysihtml5-dialog="createLink"] a.close,[data-wysihtml5-dialog="insertImage"] a.close').css({
              float: 'right',
              border: '0px'
            });

            $('[data-wysihtml5-dialog-action="save"]').removeClass('btn-primary').addClass('btn-success');
          },
          change: function() {
            var description_length = $("<p>" + $('#campaign_description').html() + "</p>").text().length;
            if (description_length > 300) {
              that.description_error_message = 'The description cannot be more than 300 characters';
              that.description_error = true;
            } else {
              that.description_error_message = '';
              that.description_error = false;
            }
            that.campaign_description = $('#campaign_description').html();
          }
        }
      });

      $('#campaign_description').on("keydown", function() {
        var description_length = $($('#campaign_description').html()).text().length;
        if (description_length > 300) {
          that.description_error_message = 'The description cannot be more than 300 characters';
          that.description_error = true;
        } else {
          that.description_error_message = '';
          that.description_error = false;
        }
        that.campaign_description = $('#campaign_description').html();
      });

      var countries = helpers.countries,
        transformedCountries = _.map(countries, function(country) {
          return { text: country.country, value: country.code };
        });
      this.$set('countries', transformedCountries);

      this.$nextTick(function() {
        this.setupPaymentEvents();
      });

      for (var m = 1; m <= 12; m++) {
        this.months.push(m);
      }

      var currentYear = moment().year();
      for (var y = currentYear; y <= currentYear + 10; y++) {
        this.years.push(y);
      }

      if (this.isAPIOrder()) {
        this.auto_import_to_shopify = true;
        this.$root.campaignData.auto_import_to_shopify = true;

        this.auto_visible_product_shopify = true;
        this.$root.campaignData.auto_set_visibility = true;

        this.$nextTick(function() {
          $('[name="auto_import_shopify"]').bootstrapSwitch({
            onText: 'YES',
            offText: 'NO',
            onColor: 'success',
            offColor: 'danger',
            size: 'normal',
            state: that.auto_import_to_shopify
          }).on('switchChange.bootstrapSwitch', function(e, state) {
            that.auto_import_to_shopify = state;
            that.$root.$set('campaignData.auto_import_to_shopify', state);
            that.$root.$set('campaignData.shopify_collection', '');
          });

          $('[name="auto_set_visibility"]').bootstrapSwitch({
            onText: 'YES',
            offText: 'NO',
            onColor: 'success',
            offColor: 'danger',
            size: 'normal',
            state: that.auto_visible_product_shopify
          }).on('switchChange.bootstrapSwitch', function(e, state) {
            that.auto_visible_product_shopify = state;
            that.$root.$set('campaignData.auto_set_visibility', state);
          });

          $('[name="import_back_images"]').bootstrapSwitch({
            onText: 'YES',
            offText: 'NO',
            onColor: 'success',
            offColor: 'danger',
            size: 'normal',
            state: this.import_back_images,
          }).on('switchChange.bootstrapSwitch', function(e, state) {
            that.import_back_images = state;
            that.$root.$set('campaignData.import_back_images', state);
          });
        });


        this.getShopifyStoreDetails();
      }
    },
    fetchEmailList: function() {
      var that = this;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'refresh-mail-list').then(function(res) {
        var data = res.data;
        var list = _.map(data.mail_list, function(item) {
          return { text: item.name, value: item.value }
        });
        that.$set('emailList', list);
        that.getDefaultEmailList();
      })
    },
    getDefaultEmailList: function() {
      var that = this;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'default-mail-list').then(function(res) {
        var data = res.data;
        that.selectedEmailList = data.id;
      })
    },
    setDefaultDate: function() {
      //Setting a default date - Choosing the 7th day which is at index 3
      $('.datetimepicker-days td.day:not(.disabled)')[3].click();
      //Setting the default hour
      $('.datetimepicker-hours span.hour:not(.disabled)')[0].click();
      //Reverting the date control back to showing the month view
      $('.datetimepicker-hours .switch').click();
    },
    gotoDetails: function() {
      $('#form_wizard_1').bootstrapWizard('show', 1);
    },
    slugify: function() {
      if (this.campaign_name != '' && this.campaign_name.length >= 4) {
        this.campaign_url = helpers.slugify($(this.$event.currentTarget).val().substring(0, 40));
        this.validateURL(this.campaign_url);
      }
    },
    toggleAdvanced: function() {
      var that = this;
      this.showAdvanced = !this.showAdvanced;
      setTimeout(function() {
        that.initializeToggles();
        $('[data-toggle="popover"]').popover({ html: true });
      }, 200);
      return false;
    },
    initializeToggles: function() {
      var that = this;
      this.toggleInitialized = true;

      $('[name="CLONE-UPSELLS"]').bootstrapSwitch({
        onText: 'YES',
        offText: 'NO',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal',
        state: that.clone_upsells
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.clone_upsells = state
        that.$root.$set('campaignData.clone_upsells', state);
        that.$broadcast('disable-upsell-configuration', state)
      });

      $('[name="CLONE-PIXELS"]').bootstrapSwitch({
        onText: 'YES',
        offText: 'NO',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal',
        state: that.clone_pixels
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.clone_pixels = state
        that.$root.$set('campaignData.clone_pixels', state);
      });

      $('[name="AUTO-RELAUNCH"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.campaign_auto_relaunch', state);
      });

      $('[name="PAGE-TIMER"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.campaign_page_timer', state);
      });

      $('[name="SHOW-GOAL"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.campaign_show_goal', state);
      });

      $('[name="AUTO-EXTEND"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.campaign_auto_extend', state);
      });

      $('[name="DTG-AUTO-GOAL-DROP"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        var dtgValidation = that.validateSellingPriceforDTG();
        if (dtgValidation.status === true) {
          $('[name="DTG-AUTO-GOAL-DROP"]').bootstrapSwitch('state', false, true);
          helpers.alert(dtgValidation.message);
        } else {
          that.$root.$set('campaignData.campaign_dtg_auto_goal_drop', state);
        }
      });

      $('[name="SHOW-BACK-DEFAULT"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.campaign_show_back_default', state);
      });

      $('[name="discoverable_on_marketplace"]').bootstrapSwitch({
        onText: 'ON',
        offText: 'OFF',
        onColor: 'success',
        offColor: 'danger',
        size: 'normal'
      }).on('switchChange.bootstrapSwitch', function(e, state) {
        that.$root.$set('campaignData.hide_marketplace', !state);
      });

      $('[name="AUTO-RELAUNCH"]').bootstrapSwitch('state', this.$root.campaignData.campaign_auto_relaunch);
      $('[name="PAGE-TIMER"]').bootstrapSwitch('state', this.$root.campaignData.campaign_page_timer);
      $('[name="SHOW-GOAL"]').bootstrapSwitch('state', this.$root.campaignData.campaign_show_goal);
      $('[name="AUTO-EXTEND"]').bootstrapSwitch('state', this.$root.campaignData.campaign_auto_extend);
      $('[name="DTG-AUTO-GOAL-DROP"]').bootstrapSwitch('state', this.$root.campaignData.campaign_dtg_auto_goal_drop);
      $('[name="SHOW-BACK-DEFAULT"]').bootstrapSwitch('state', this.$root.campaignData.campaign_show_back_default);
      $('[name="discoverable_on_marketplace"]').bootstrapSwitch('state', !this.$root.campaignData.hide_marketplace);

      if (this.$root.selectedProduct.product.back_view === 'HIDE') {
        $('[name="SHOW-BACK-DEFAULT"]').bootstrapSwitch('disabled', true);
      }
    },
    setupPaymentEvents: function() {
      $('a[rel=popover]').popover({
        html: true,
        trigger: 'hover',
        placement: 'top',
        content: function() {
          return '<img src="' + $(this).data('img') + '" />';
        }
      });

      $('[data-input="CARD-NUMBER"]').payment('formatCardNumber');
      $('[data-input="CARD-CVV"]').payment('formatCardCVC');

    },
    launchCampaign: function() {
      this.$root.campaignData.isDraft = false;
      this.saveCampaign(false);
    },
    saveCampaign: function(isAutoSave) {
      this.$root.outputDesign();
      var cloneCampaignData = _.clone(this.$root.campaignData, true),
        that = this;

      that.buttonClick = false;

      if (that.selectedProduct) {
        if (that.selectedProduct.product.sublimation == 1) {
          cloneCampaignData.design.front.original = '';
          cloneCampaignData.design.front.upscaled = '';
          cloneCampaignData.design.back.original = '';
          cloneCampaignData.design.back.upscaledback = '';
        }
      }

      if (this.isAPIOrder()) {
        if (_.isEmpty(cloneCampaignData.campaign_description))
          cloneCampaignData.campaign_description = cloneCampaignData.campaign_name;
      }

      var data = {
        campaign_data: JSON.stringify(this.$root.clearDesignData(cloneCampaignData)).replace(/[\u200B-\u200D\uFEFF]/g, ''),
        _token: $('#_token').val()
      };

      var campaignValidations = this.$root.validateCampaign();
      if (campaignValidations.length > 0) {
        var html = "The following fields are required to create the campaign. <br> <ul>{{validationFields}}</ul>";
        var compiled = _.template('<% _.forEach(data, function(field) { %><li><%- field %></li><% }); %>');
        this.$set('validationFields', compiled({ data: campaignValidations }));
        helpers.alert(this.$interpolate(html));
        return false;
      } else {
        if (this.isAPIOrder() && this.shopifyVariantsEnabled === true) {
          var variants = this.getVariants();

          if (variants.length > 100) {
            var message = "The number of variants selected is more than 100 which exceeds the maximum allowed by Shopify. " +
              "This campaign will be imported with ​<b>Use Product Style As Variant​ switched ​Off​</b>. " +
              "This setting will be switched <b>​Off​</b> only for this campaign. <br><br>Are you sure you want to proceed?";

            helpers.confirm(message, function() {
              that.storeCampaign(isAutoSave, data);
            }, function() {
              return false;
            });
          } else {
            this.storeCampaign(isAutoSave, data);
          }
        } else {
          this.storeCampaign(isAutoSave, data);
        }
      }
    },
    storeCampaign: function(isAutoSave, data) {
      var that = this;
      if (isAutoSave === false)
        helpers.showProcessing(true);
      else
        NProgress.start();

      var requestService = this.$root.service.request.object;
      requestService.oAuthPost(`${requestService.apiBase}/designer/store`, data, (response) => {
        var resp = response.data;
        if (resp.message == "Success") {
          var res = resp.data;
          if (that.$root.campaignData.isDraft === false) {
            if (typeof Intercom !== 'undefined') {
              Intercom('trackEvent', 'campaign-created');
            }
            if (typeof ga !== 'undefined') {
              ga('send', {
                hitType: 'event',
                eventCategory: 'Client',
                eventAction: 'Campaign Launch',
                eventLabel: 'Main'
              });
            }
            if (typeof fbq !== 'undefined') {
              fbq('track', 'CompleteRegistration');
            }

            setTimeout(function() {
              that.$root.warnBeforeNavigation = false;
              if (that.isManualOrder()) {
                var order_id = res.data.order_id;
                helpers.redirectWithValues('/purchase/thank-you', { order_id: order_id });
              } else if (that.isAPIOrder()) {
                if (URI().hasQuery('naked')) {
                  window.parent.postMessage(JSON.stringify({
                    event: 'CAMPAIGN_CREATED',
                    id: res.campaign_id
                  }), 'https://' + window.location.host);
                } else {
                  location.href = '/client/profile/api#tab_api_campaigns';
                }
              } else {
                if (res.redirect_url) {
                  location.href = res.redirect_url;
                } else {

                  var isLegacy = !isNaN(parseFloat(res.campaign_id)) && isFinite(res.campaign_id);

                  if (isLegacy) {
                    location.href = '/client/campaigns/' + res.campaign_id;
                  } else {

                    location.href = '/client/campaigns/' + res.campaign_id + '/details/info';
                  }
                }
              }
            }, 200);

          } else {
            if (isAutoSave === false) {
              helpers.alert('Your campaign has been saved as a draft, and can be located under the drafts tab in the campaign table');
              that.$root.warnBeforeNavigation = false;
            }
            helpers.hideProcessing();
          }
          that.$root.$set('campaignData.campaignId', res.campaign_id);
          that.$root.$set('campaignData.campaignUniqueId', res.unique_id);
        } else {
          var message = response.data.message ? response.data.message : response.message;
          message = message || 'There was an error creating the campaign. <br> If this issue persists, please contact Customer Support';

          helpers.alert(message);
          helpers.hideProcessing();
        }
        if (isAutoSave === true)
          NProgress.done();
      }, (response) => {

        if (response.data && response.data.status_code == 412) {
          var message = 'We\'re sorry, you must validate your email address before creating a campaign. Please click the link you received when you registered or click <a id="resend-validation" href="javascript:void(0)">here to resend the welcome email.</a>';
        } else {
          var message = response.data.message ? response.data.message : response.message;
          message = message || 'There was an error creating the campaign. <br> If this issue persists, please contact Customer Support';
        }

        helpers.alert(message);
        helpers.hideProcessing();
        that.buttonClick = true;
      });
    },
    draftCampaign: function(autoSave) {
      this.$root.campaignData.isDraft = true;
      this.saveCampaign(autoSave ? true : false);
    },
    clearDesignData: function(data) {
      var sides = ['front', 'back'];
      _.each(sides, function(side) {
        var designItems = data.mainProduct[side].designerItems,
          imageItems = _.filter(designItems, function(item) {
            return item.type == "IMAGE" || item.type == "ARTWORK";
          });

        _.each(imageItems, function(item) {
          if (item.type == "IMAGE") {
            delete item.imageData.original_encoded;
            delete item.imageData.thumbnail_encoded;
          } else {
            delete item.value;
          }
        })
      });

      return data;
    },
    setUTCTime: function(selectedTime) {
      var matches = selectedTime.match(/.+, (.+) - (\d{2}) ([APM]{2})/);

      var date = null;
      if (!matches) {
        date = new Date();
        date.setDate(date.getDate() + 4);
        this.$root.$set('campaignData.campaign_end_date_utc', date.getTime());
      } else {
        date = new Date(matches[1]);
        var hours = 0;
        var hour = parseInt(matches[2]);
        var meridian = matches[3];

        if (meridian === 'AM') {
          if (hour !== 12) {
            hours = hours + hour;
          }
        } else {
          hours = hours + 12 + hour;
        }

        date.setHours(date.getHours() + hours);
        this.$root.$set('campaignData.campaign_end_date_utc', date.getTime());
      }
    },
    validateURL: function(url) {
      var that = this,
        formGroup = $('#campaign_url').parents('.form-group:eq(0)');
      if (url != '' && url.length >= 4) {
        Vue.http.post(this.$root.getRequestService().ajaxBase + 'check-url', { url: url }).then(function(response) {
          var res = response.data;
          if (res.status === "SUCCESS") {
            $(formGroup).removeClass('has-error').addClass('has-success has-feedback');
            $(formGroup).find('span.glyphicon').remove();
            that.$root.$set('campaignData.campaign_url', url);
            that.url_exists = false;
            that.url_error_message = '';
          } else {
            $(formGroup).removeClass('has-success').addClass('has-error has-feedback');
            $(formGroup).find('span.glyphicon').remove();
            that.$root.$set('campaignData.campaign_url', '');
            that.url_exists = true;
            that.url_error_message = res.message;
          }
        });
      } else {
        $(formGroup).removeClass('has-success').addClass('has-error has-feedback');
        $(formGroup).find('span.glyphicon').remove();
        that.$root.$set('campaignData.campaign_url', '');
        that.url_exists = true;
        that.url_error_message = 'The length of the URL should be between 4-100 characters';
      }
    },
    validateSellingPriceforDTG: function() {
      var block = false,
        mainProductSellingPrice = parseFloat(this.$root.campaignData.pricing.sellingPrice),
        mainProductDTGPrice = this.$root.campaignData.pricing.dtgPrice,
        mainProductBasePrice = this.$root.campaignData.pricing.basePrice,
        message = '';

      if (this.isSpecialPrint()) {
        var addonCost = this.$root.getAddonCost(1, true);
        if (this.isEmbroidery()) {
          var dtgCostWithAddon = parseFloat(mainProductDTGPrice) + parseFloat(addonCost);
          if (dtgCostWithAddon > mainProductSellingPrice) {
            block = true;
            message = "To enable 'DTG/Auto Goal-Drop', the selling price of a product cannot be less that the Base cost of 1 product sold";
          }
        } else {
          var baseCostWithAddon = parseFloat(mainProductBasePrice) + parseFloat(addonCost);
          if (baseCostWithAddon > mainProductSellingPrice) {
            block = true;
            message = "To enable 'DTG/Auto Goal-Drop', the selling price of a product cannot be less that the Base cost of 1 product sold";
          }
        }
      }

      if ((mainProductSellingPrice < mainProductDTGPrice) && block === false) {
        block = true;
        message = "To enable 'DTG/Auto Goal-Drop', the selling price of a product cannot be less than the DTG cost.";
      }

      if (block === false)
        _.each(this.$root.campaignData.additionalProducts, function(additionalProduct) {
          if (+additionalProduct.selling_price < +additionalProduct.dtg_price) {
            block = true;
            message = "To enable 'DTG/Auto Goal-Drop', the selling price of a product cannot be less than the DTG cost.";
          }
        });

      return { 'status': block, 'message': message };
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    },
    isManualOrder: function() {
      return this.$root.isManualOrder();
    },
    groupProductsForSale: function(sizesWithCount, product, color, eventCall) {
      if (this.$root.isManualOrder()) {
        var productId = product.id;
        var currentProduct = this.getProductForSale(productId);

        if (currentProduct) {
          var currentColor = _.find(currentProduct.colors, function(colorObj) {
            return colorObj.id == color.color;
          });

          if (currentColor) {
            currentColor['sizes'] = sizesWithCount;
          } else {
            currentProduct.colors.push({
              id: color.color,
              hex: color.hex,
              sizes: sizesWithCount
            });
          }
        } else {
          this.productsOrders.push({
            id: productId,
            colors: [{
              id: color.color,
              hex: color.hex,
              sizes: sizesWithCount
            }],
            product: product
          });
        }

        var currentProductCount = this.getProductSaleCount();
        this.$root.campaignData.goal = currentProductCount;

        if (currentProductCount > 0)
          return this.getPricingByProduct(product, parseInt(currentProductCount, 10));
        else
          return 0.00;
      }

    },
    getProductForSale: function(productId) {
      return _.find(this.productsOrders, function(product) {
        return product.id == productId;
      });
    },
    getProductSaleCount: function() {
      var saleCount = 0;
      _.each(this.productsOrders, function(product) {
        var colors = product.colors;
        _.each(colors, function(color) {
          var sizes = color.sizes;
          saleCount += (parseInt(sizes.S) || 0) + (parseInt(sizes.M) || 0) + (parseInt(sizes.L) || 0) +
            (parseInt(sizes.XL) || 0) + (parseInt(sizes.TWO_XL) || 0) + (parseInt(sizes.THREE_XL) || 0) +
            (parseInt(sizes.FOUR_XL) || 0) + (parseInt(sizes.FIVE_XL) || 0);
        });
      });

      return saleCount;
    },
    getSaleSubTotal: function() {
      var that = this,
        calculatedPrices = 0.00,
        products = this.productsOrders;

      _.each(products, function(product) {
        var colors = product.colors,
          productObj = product.product,
          upChargeCost = JSON.parse(productObj.upcharges),
          saleCount = that.getProductSaleCount();

        if (saleCount > 0) {
          var productPrice = parseFloat(that.getPricingByProduct(product.product, parseInt(saleCount, 10)));

          _.each(colors, function(color) {
            var sizes = color.sizes;

            if (sizes.S > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.S, 10) * productPrice));
            }

            if (sizes.M > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.M, 10) * productPrice));
            }

            if (sizes.L > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.L, 10) * productPrice));
            }

            if (sizes.XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.XL, 10) * parseFloat(upChargeCost['XL']))));
            }

            if (sizes.TWO_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.TWO_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.TWO_XL, 10) * parseFloat(upChargeCost['2XL']))));
            }

            if (sizes.THREE_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.THREE_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.THREE_XL, 10) * parseFloat(upChargeCost['3XL']))));
            }

            if (sizes.FOUR_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.FOUR_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.FOUR_XL, 10) * parseFloat(upChargeCost['4XL']))));
            }

            if (sizes.FIVE_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.FIVE_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.FIVE_XL, 10) * parseFloat(upChargeCost['5XL']))));
            }
          });
        }
      });

      return calculatedPrices;
    },
    hoodieExists: function() {
      var exists = _.indexOf(this.productsOrders, function(product) {
        return product.id == 5;
      });

      return exists > -1;
    },
    getShipping: function() {
      var countryToShip = this.purchases.buyer.country,
        shippingCost = this.$root.shipping_rates,
        cost = {},
        baseCost = 0.00,
        additionalCost = 0.00,
        saleCount = this.getProductSaleCount();

      if (saleCount > 0) {
        if (shippingCost.hasOwnProperty('SHIPPING_US')) {
          if (countryToShip == "US" || countryToShip === undefined) {
            cost = JSON.parse(shippingCost.SHIPPING_US);
          } else if (countryToShip == "CA") {
            cost = JSON.parse(shippingCost.SHIPPING_CANADA);
          } else {
            cost = JSON.parse(shippingCost.SHIPPING_INTERNATIONAL);
          }

          baseCost = parseFloat(cost.default);
          // If Hoodie Product in order add $3
          if (this.hoodieExists()) {
            baseCost += 3.00;
          }

          additionalCost = (parseInt(saleCount - 1, 10) * parseFloat(cost.addition));

          return baseCost + additionalCost;
        } else
          return 0.00;
      } else
        return 0.00;
    },
    getTotalPrice: function() {
      return parseFloat(this.getSaleSubTotal()) + parseFloat(this.getShipping());
    },
    createManualOrder: function() {
      var that = this,
        buyer = this.purchases.buyer,
        card = this.purchases.payment.cc;
      this.updateProductPricesForManualOrder();
      this.updateBuyerInfo();
      if (this.validateManualOrder()) {
        this.buttonClick = false;
        helpers.showProcessing(false);
        cardProvider.tokenize(buyer.name, card.card_num, card.card_month, card.card_year, card.card_cvv, function(token) {
          that.$root.campaignData.isDraft = false;
          that.$root.campaignData.manual_order = true;
          that.$root.campaignData.purchases.payment.cc.token = token;
          that.$root.campaignData.purchases.payment.cc.cc_bin = card.card_num.replace(/\s/g, '').substr(0, 6);
          that.saveCampaign(false);
        }, function(err) {
          helpers.alert(err);
          helpers.hideProcessing(false);
          this.buttonClick = true;
        });
      }
    },
    validateManualOrder: function() {
      var salesCount = this.getProductSaleCount(),
        validations = [],
        buyer = this.purchases.buyer,
        card = this.purchases.payment.cc;

      if (salesCount == 0) {
        validations.push('Atleast 1 product needs to be purchased to place the order. <br>Please use the Order Information section to add products to the sale');
      }

      if (buyer.email == "")
        validations.push('Email Id is required.');
      else {
        if (is.email(buyer.email) === false)
          validations.push('Email Id provided is invalid');
      }

      if (buyer.name == "") {
        validations.push('Full Name is required.');
      }

      if (buyer.address == "") {
        validations.push('Address is required.');
      }

      if (buyer.city == "") {
        validations.push('City is required.');
      }

      if (buyer.state == "") {
        validations.push('State is required');
      }

      if (buyer.zip == "") {
        validations.push((buyer.country == "US" ? 'ZIP Code' : 'Postal Code') + ' is required');
      }

      if (card.card_num == "") {
        validations.push('Credit Card Number is required');
      } else {
        if ($.payment.validateCardNumber(card.card_num) === false)
          validations.push('Invalid Credit Card Number');
      }

      if (card.card_month == "" || card.card_year == "") {
        validations.push('Credit Card Expiry is required');
      } else {
        if ($.payment.validateCardExpiry(card.card_month, card.card_year) === false) {
          validations.push('Invalid Credit Card Expiry');
        }
      }

      if (card.card_cvv == "") {
        validations.push('Credit Card CVV Code is required');
      } else {
        if ($.payment.validateCardCVC(card.card_cvv) === false) {
          validations.push('Invalid Credit Card CVV Code');
        }
      }

      if (this.$root.campaignData.accept_terms === false) {
        validations.push('Agree and Accept Terms of Services');
      }

      if (validations.length > 0) {
        var html = "The following errors need to be corrected before placing the order: <br/><ul>";
        _.each(validations, function(validation) {
          html += '<li>' + validation + '</li>';
        });
        html += '</ul>';

        helpers.alert(html);
      }
      return validations.length == 0;
    },
    getPurchaseList: function() {
      var purchaseList = [];

      _.each(this.productsOrders, function(product) {
        var colors = product.colors;
        _.each(colors, function(color) {
          var sizes = color.sizes;

          if (sizes.S > 0)
            purchaseList.push({
              productId: product.id,
              size: 'S',
              qty: sizes.S,
              color: color.id
            });

          if (sizes.M > 0)
            purchaseList.push({
              productId: product.id,
              size: 'M',
              qty: sizes.M,
              color: color.id
            });

          if (sizes.L > 0)
            purchaseList.push({
              productId: product.id,
              size: 'L',
              qty: sizes.L,
              color: color.id
            });

          if (sizes.XL > 0)
            purchaseList.push({
              productId: product.id,
              size: 'XL',
              qty: sizes.XL,
              color: color.id
            });

          if (sizes.TWO_XL > 0)
            purchaseList.push({
              productId: product.id,
              size: '2XL',
              qty: sizes.TWO_XL,
              color: color.id
            });

          if (sizes.THREE_XL > 0)
            purchaseList.push({
              productId: product.id,
              size: '3XL',
              qty: sizes.THREE_XL,
              color: color.id
            });

          if (sizes.FOUR_XL > 0)
            purchaseList.push({
              productId: product.id,
              size: '4XL',
              qty: sizes.FOUR_XL,
              color: color.id
            });

          if (sizes.FIVE_XL > 0)
            purchaseList.push({
              productId: product.id,
              size: '5XL',
              qty: sizes.FIVE_XL,
              color: color.id
            });
        });
      });

      return purchaseList;
    },
    updateProductPricesForManualOrder: function() {
      var additionalProducts = this.$root.campaignData.additionalProducts,
        groupedProducts = _.groupBy(additionalProducts, function(product) {
          return product.product;
        }),
        product = this.$root.selectedProduct.product,
        salesCount = this.getProductSaleCount(),
        mainProductPrice = this.getPricingByProduct(product, salesCount),
        allProducts = this.$root.all_products,
        groupedProductKeys = _.keys(groupedProducts),
        that = this;

      this.$root.$set('campaignData.pricing', {
        basePrice: mainProductPrice,
        sellingPrice: mainProductPrice,
        dtgPrice: this.$root.getDTGPricing(product)
      });

      _.each(groupedProductKeys, function(product) {
        var productObj = _.find(allProducts, function(p) {
            return p.products.id == product;
          }),
          pricing = that.getPricingByProduct(productObj.products, salesCount);

        var colors = groupedProducts[product];
        _.each(colors, function(color) {
          color.selling_price = pricing;
          color.base_price = pricing;
          color.profit = 0;
        });
      });
    },
    updateProductPurchaseCounts: function() {
      var products = this.productsOrders;

      _.each(products, function(product) {
        var colors = product.colors,
          productObj = product.product,
          upChargeCost = JSON.parse(productObj.upcharges),
          saleCount = that.getProductSaleCount(),
          calculatedPrices = 0.00;

        if (saleCount > 0) {
          var productPrice = parseFloat(that.getPricingByProduct(product.product, parseInt(saleCount, 10)));

          _.each(colors, function(color) {
            var sizes = color.sizes;

            if (sizes.S > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.S, 10) * productPrice));
            }

            if (sizes.M > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.M, 10) * productPrice));
            }

            if (sizes.L > 0) {
              calculatedPrices += (parseFloat(parseInt(sizes.L, 10) * productPrice));
            }

            if (sizes.XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.XL, 10) * parseFloat(upChargeCost['XL']))));
            }

            if (sizes.TWO_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.TWO_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.TWO_XL, 10) * parseFloat(upChargeCost['2XL']))));
            }

            if (sizes.THREE_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.THREE_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.THREE_XL, 10) * parseFloat(upChargeCost['3XL']))));
            }

            if (sizes.FOUR_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.FOUR_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.FOUR_XL, 10) * parseFloat(upChargeCost['4XL']))));
            }

            if (sizes.FIVE_XL > 0) {
              calculatedPrices += parseFloat(((parseFloat(parseInt(sizes.FIVE_XL, 10) * productPrice))) +
                (parseFloat(parseInt(sizes.FIVE_XL, 10) * parseFloat(upChargeCost['5XL']))));
            }
          });
        }
      });
    },
    updateBuyerInfo: function() {
      var buyerDetails = this.purchases.buyer,
        boughtProducts = this.getPurchaseList();

      if (buyerDetails.country == 'US' || buyerDetails.country == 'CA') {
        buyerDetails.state = this.stateDropdown;
      } else {
        buyerDetails.state = this.stateText;
      }
      this.$root.$set('campaignData.purchases.buyer', buyerDetails);
      this.$root.$set('campaignData.purchases.products', boughtProducts);
    },
    manageStateField: function(countryCode) {
      this.stateDropdown = '';
      this.stateText = '';
      if (countryCode == "US") {
        this.showStateDropdown = true;
        this.states = _.map(helpers.us_states, function(state) {
          return {
            value: state.StateCode,
            text: state.Name
          };
        });
        $('#txtPostal').mask('99999', { placeholder: '' });
        this.stateLabel = 'State';
        this.zipLabel = 'ZIP Code';
      } else if (countryCode == "CA") {
        this.showStateDropdown = true;
        this.states = _.map(helpers.ca_provinces, function(state) {
          return {
            value: state.StateCode,
            text: state.Name
          };
        });
        $('#txtPostal').mask('AAA AAA', { placeholder: '' });
        this.stateLabel = 'Province';
        this.zipLabel = 'Postal Code';
      } else {
        this.showStateDropdown = false;
        this.states = [];
        $('#txtPostal').unmask();
        this.stateLabel = 'Province/State';
        this.zipLabel = 'Postal Code';
      }
    },
    isSpecialPrint: function() {
      return this.$root.isSpecialPrint() === true;
    },
    isEmbroidery: function() {
      return this.$root.isEmbroideryProduct() === true;
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    },
    getCategories: function() {
      var that = this;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'categories').then(function(resp) {
        var response = resp.data,
          categories = [];
        if (response.status = "SUCCESS") {
          categories = response.data;
        }

        that.$set('campaignCategories', categories);
        that.$nextTick(function() {
          var selectObject = $('[name="parent_category"]').selectize();
          selectObject.on('change', function(e, val) {
            that.$root.$set('campaignData.category', $(this).val());
          });
          that.categoriesDropdownObject = selectObject;

          if(that.$root.campaignData.category) {
            that.categoriesDropdownObject[0].selectize.setValue(parseInt(that.$root.campaignData.category));
          }
        });
      });
    },
    getPricingByProduct(product, goal) {
      return this.$root.getPricingByProduct(product, goal);
    },
    getWhitelabelAccountDetails() {
      var self = this;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'white-label-details').then(function(response) {
        var res = response.data;
        if (res.status === "SUCCESS") {
          self.isWhiteLabel = true;
          _.each(res.domains, function(domain) {
            self.domainList.push(domain)
          });

        }

      });
    },
    getShopifyStoreDetails() {
      var self = this,
        domain = new URI().search(true).d;
      Vue.http.get(this.$root.getRequestService().ajaxBase + 'shopify-store-details?d=' + domain).then(function(response) {
        const data = response.data,
          collections = data.store_collections,
          isPaymentSetup = data.payment_setup,
          variantsEnabled = data.variants_enabled;

        collections.splice(0, 0, {
          value: 'USE_CAMPAIGN',
          text: 'Use campaign name as collection name'
        });
        collections.splice(0, 0, {
          value: '',
          text: 'Do not assign a Collection'
        });

        self.$root.shopify.collections = collections;
        self.$root.shopify.isPaymentSetup = isPaymentSetup;
        self.shopify_collections = collections;
        self.$root.campaignData.shopifyDomain = domain;
        self.shopifyVariantsEnabled = variantsEnabled;

        self.$nextTick(function() {
          var select = $('#shopify_collections').selectize({
            create: true,
            createOnBlur: true,
          }).on('change', function(e, val) {
            self.$root.$set('campaignData.shopify_collection', $(this).val());
          });

          var selectize = select[0].selectize;
          selectize.refreshOptions();
        });

        if (self.$root.shopify.isPaymentSetup == false) {
          $('[name="auto_import_shopify"]').bootstrapSwitch('state', false);
          $('[name="auto_import_shopify"]').bootstrapSwitch('disabled', true);

          $('[name="auto_set_visibility"]').bootstrapSwitch('state', false);
          $('[name="auto_set_visibility"]').bootstrapSwitch('disabled', true);

          $('[name="import_back_images"]').bootstrapSwitch('state', false);
          $('[name="import_back_images"]').bootstrapSwitch('disabled', true);
        }
      });
    },
    getVariants() {
      var variants = this.$root.getVariants();
      return variants;
    },
    getProductNameById(id) {
      var product = this.$root.getProductById(id);
      return product.products.name;
    },
    getVariantsCountByProductId(id) {
      return this.$root.getVariantsByProduct(id).length;
    },
    setSelectedDomainId(val) {
      this.$set('selectedDomainId', val);
      this.$root.$set('campaignData.domain_id', val);
    },

  },
  computed: {
    variantsCount() {
      return this.getVariants().length;
    },
    groupedProductsForDesignAndPurchase: function() {
      var additionalProducts = this.$root.campaignData.additionalProducts,
        groupedProducts = _.groupBy(additionalProducts, function(product) {
          return product.product;
        }),
        allProducts = this.$root.all_products,
        productsInfo = [],
        mainProduct = this.$root.campaignData.mainProduct;

      if (mainProduct.product.hasOwnProperty('product'))
        if (groupedProducts.hasOwnProperty(mainProduct.product.product.id))
          groupedProducts[mainProduct.product.product.id].unshift({
            color: mainProduct.currentColor.id,
            hex: mainProduct.currentColor.hex
          });
        else {
          groupedProducts[mainProduct.product.product.id] = [];
          groupedProducts[mainProduct.product.product.id].unshift({
            color: mainProduct.currentColor.id,
            hex: mainProduct.currentColor.hex
          });
        }

      var groupedProductKeys = _.keys(groupedProducts);

      //Getting All the Product Info for each of the grouped Product
      _.each(groupedProductKeys, function(product) {
        var productObj = _.find(allProducts, function(p) {
          return p.products.id == product;
        });

        productsInfo.push({
          obj: productObj.products,
          colors: groupedProducts[product]
        });
      });

      return productsInfo;
    },
    userURL() {
      var user = this.$root.service.user.object;

      if (user) {

        var domain = this.getSelectedDomain;

        if (!this.isWhiteLabel || domain == 'viralstyle.com') {
          var public_name = user.user_info.public_name;
          return `https://${domain}/${public_name}/`;
        } else {
          return `http://${domain}/`;
        }
      }
    },
    getSelectedDomain() {
      var self = this;

      var domain = 'viralstyle.com';

      if (this.selectedDomainId) {
        _.each(this.domainList, function(item) {
          if (item.value === self.selectedDomainId) {
            domain = item.text;
          }
        });
      }

      return domain;
    },
    groupedCampaignCategories() {
      return _.groupBy(this.campaignCategories, 'name');
    },
    individualProducts() {
      var mainProduct = this.$root.campaignData.mainProduct;
      if (mainProduct.product.hasOwnProperty('product')) {
        var additionalProducts = this.$root.campaignData.additionalProducts,
          products = [],
          mainProductId = mainProduct.product.product.id;

        products.push(mainProductId);

        _.each(additionalProducts, function(product) {
          var productId = product.product,
            productExists = _.find(products, function(product) {
              return product == productId;
            });

          if (productExists == undefined)
            products.push(productId);
        });

        return products;
      }
      return [];
    },
    isBackEnabledOnMainProduct() {
      var mainProduct = this.$root.campaignData.mainProduct;
      if (mainProduct.product.hasOwnProperty('product')) {
        return this.$root.campaignData.mainProduct.product.product.back_view === "SHOW";
      }
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/launch_tab/index.js